//@ts-check

const theme = {
  deterministicClasses: true,
  common: {
    Page: {
      /** Navigation bar on the top of the screen. */
      Common: {
        style: {
          backgroundColor: '#ffffff',
        },
      },
    },
    Alert: {
      style: { textColor: '#a94442' },
      Wrapper: {
        style: {
          backgroundColor: 'rgb(242, 222, 222)',
          border: '1px solid rgb(235, 204, 209)',
          padding: '15px',
        },
      },
    },
  }  
};

export default theme;
